import Image from 'next/image';

import { cn } from '@/lib/utils';

/**
 * Country flag from an ISO 3166-1 alpha-2 code, rendered as a flagcdn.com PNG so
 * it looks identical on every OS (Windows' emoji font has no flag glyphs, so raw
 * flag emoji fall back to the two ISO letters there).
 *
 * `unoptimized` — these are already tiny fixed-size CDN PNGs, and it keeps this a
 * Server Component. Renders nothing without a valid code.
 */
export function CountryFlag({
  country,
  className,
}: {
  country: string | null | undefined;
  className?: string;
}) {
  const cc = country?.trim().toLowerCase();
  if (!cc || !/^[a-z]{2}$/.test(cc)) return null;

  return (
    <Image
      src={`https://flagcdn.com/w40/${cc}.png`}
      alt=""
      width={24}
      height={18}
      unoptimized
      className={cn('h-[2.25rem] w-[3rem] shrink-0 rounded-[0.375rem] object-cover', className)}
    />
  );
}
